import { FC, ReactNode, useEffect, useState } from 'react';

import { createPortal } from 'react-dom';

const MINIMIZED_DOCK_ID = 'minimized-dock';

/**
 * Bottom-right stack shared by minimized popups (Zoom Phone, Send Mail).
 * Items stack upward in the order they appear, so no popup needs to know
 * whether another one is minimized. Rendered once in the app shell.
 */
const MinimizedDock: FC = () => (
  <div
    id={MINIMIZED_DOCK_ID}
    className='fixed bottom-5 right-5 z-[1000] flex flex-col-reverse items-end gap-3'
  />
);

/** Renders its children into the MinimizedDock. */
export const MinimizedDockItem: FC<{ children: ReactNode }> = ({
  children
}) => {
  const [dock, setDock] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setDock(document.getElementById(MINIMIZED_DOCK_ID));
  }, []);

  return dock ? createPortal(children, dock) : null;
};

export default MinimizedDock;
